var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "div",
        { staticClass: "q-display-1 q-mb-md text-secondary" },
        [
          _c("q-icon", {
            staticClass: "q-mb-sm",
            attrs: { name: "far fa-newspaper" }
          }),
          _vm._v(" " + _vm._s(_vm.$t(_vm.title_news)) + "\n\t")
        ],
        1
      ),
      _c(
        "q-tabs",
        {
          model: {
            value: _vm.tab_content,
            callback: function($$v) {
              _vm.tab_content = $$v
            },
            expression: "tab_content"
          }
        },
        [
          _c("q-tab", {
            attrs: { slot: "title", name: "news", label: _vm.$t("news") },
            slot: "title"
          }),
          _vm.useCommentsNews
            ? _c("q-tab", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showTab,
                    expression: "showTab"
                  }
                ],
                attrs: {
                  slot: "title",
                  name: "comments",
                  label: _vm.$t("comments")
                },
                slot: "title"
              })
            : _vm._e(),
          _c(
            "q-tab-pane",
            { attrs: { name: "news" } },
            [
              _c("div", { staticClass: "row gutter-sm q-mb-lg" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12" },
                  [
                    _c(
                      "q-field",
                      { attrs: { count: 256 } },
                      [
                        _c("q-input", {
                          ref: "title",
                          attrs: {
                            "float-label": _vm.$t("title"),
                            error: _vm.$v.title.$error
                          },
                          on: { input: _vm.$v.title.$touch },
                          model: {
                            value: _vm.title,
                            callback: function($$v) {
                              _vm.title = $$v
                            },
                            expression: "title"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
                  _c("div", { staticClass: "row gutter-sm" }, [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-6" },
                      [
                        _c("p", { staticClass: "caption" }, [
                          _vm._v(_vm._s(_vm.$t("image")))
                        ]),
                        _c("uploader", {
                          attrs: {
                            content_type: "images",
                            aspect_ratio: 52 / 29,
                            aspect_ratio_string: "52/29",
                            multiple: false,
                            cropper: true
                          },
                          on: { fileUploaded: _vm.imageUploaded }
                        }),
                        _vm.image_url
                          ? _c(
                              "p",
                              { staticClass: "q-mt-md file-url" },
                              [
                                _c("q-icon", {
                                  attrs: {
                                    name: "fal fa-check",
                                    color: "positive"
                                  }
                                }),
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.image_url,
                                      target: "_blank"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t" +
                                        _vm._s(_vm.$truncateLink(_vm.image_url))
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
                      _c(
                        "p",
                        { staticClass: "caption" },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t" +
                              _vm._s(_vm.$t("alt_image")) +
                              "\n\t\t\t\t\t\t\t\t"
                          ),
                          _c(
                            "q-icon",
                            {
                              staticClass: "q-ml-sm q-pb-sm",
                              attrs: {
                                name: "fal fa-question-circle",
                                size: "1.5rem",
                                color: "grey"
                              }
                            },
                            [
                              _c(
                                "q-tooltip",
                                {
                                  staticClass: "custom-tooltip",
                                  attrs: {
                                    anchor: "top left",
                                    self: "bottom right"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.$t("alt_image_information_helper")
                                      ) +
                                      "\n\t\t\t\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "flex justify-between" },
                        [
                          _vm._l(_vm.languages, function(lang) {
                            return [
                              lang.code === "pt-br"
                                ? _c(
                                    "q-field",
                                    { key: lang.id, attrs: { count: 170 } },
                                    [
                                      _c("q-input", {
                                        ref: "language_br",
                                        refInFor: true,
                                        attrs: {
                                          "float-label": _vm.$t("" + lang.name),
                                          error: _vm.$v.language_br.$error
                                        },
                                        on: {
                                          input: _vm.$v.language_br.$touch
                                        },
                                        model: {
                                          value: _vm.language_br,
                                          callback: function($$v) {
                                            _vm.language_br = $$v
                                          },
                                          expression: "language_br"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              lang.code === "en-us"
                                ? _c(
                                    "q-field",
                                    { key: lang.id, attrs: { count: 170 } },
                                    [
                                      _c("q-input", {
                                        ref: "language_us",
                                        refInFor: true,
                                        attrs: {
                                          "float-label": _vm.$t("" + lang.name),
                                          error: _vm.$v.language_us.$error
                                        },
                                        on: {
                                          input: _vm.$v.language_us.$touch
                                        },
                                        model: {
                                          value: _vm.language_us,
                                          callback: function($$v) {
                                            _vm.language_us = $$v
                                          },
                                          expression: "language_us"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              lang.code === "es-es"
                                ? _c(
                                    "q-field",
                                    { key: lang.id, attrs: { count: 170 } },
                                    [
                                      _c("q-input", {
                                        ref: "language_es",
                                        refInFor: true,
                                        attrs: {
                                          "float-label": _vm.$t("" + lang.name),
                                          error: _vm.$v.language_es.$error
                                        },
                                        on: {
                                          input: _vm.$v.language_es.$touch
                                        },
                                        model: {
                                          value: _vm.language_es,
                                          callback: function($$v) {
                                            _vm.language_es = $$v
                                          },
                                          expression: "language_es"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              lang.code === "fr-fr"
                                ? _c(
                                    "q-field",
                                    { key: lang.id, attrs: { count: 170 } },
                                    [
                                      _c("q-input", {
                                        ref: "language_fr",
                                        refInFor: true,
                                        attrs: {
                                          "float-label": _vm.$t("" + lang.name),
                                          error: _vm.$v.language_fr.$error
                                        },
                                        on: {
                                          input: _vm.$v.language_fr.$touch
                                        },
                                        model: {
                                          value: _vm.language_fr,
                                          callback: function($$v) {
                                            _vm.language_fr = $$v
                                          },
                                          expression: "language_fr"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          })
                        ],
                        2
                      )
                    ])
                  ])
                ]),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12" },
                  [
                    _c("p", { staticClass: "caption" }, [
                      _vm._v(_vm._s(_vm.$t("content")))
                    ]),
                    _c(
                      "q-editor",
                      {
                        ref: "content",
                        attrs: {
                          toolbar: [
                            ["bold", "italic", "strike", "underline"],
                            ["left", "center", "right", "justify"],
                            ["link", "upload"],
                            [
                              {
                                label: null,
                                icon: "fas fa-font",
                                fixedLabel: true,
                                fixedIcon: true,
                                list: "no-icons",
                                options: [
                                  "p",
                                  "h1",
                                  "h2",
                                  "h3",
                                  "h4",
                                  "h5",
                                  "h6",
                                  "code"
                                ]
                              },
                              {
                                label: null,
                                icon: "fas fa-text-height",
                                fixedLabel: true,
                                fixedIcon: true,
                                list: "no-icons",
                                options: [
                                  "size-1",
                                  "size-2",
                                  "size-3",
                                  "size-4",
                                  "size-5",
                                  "size-6",
                                  "size-7"
                                ]
                              },
                              "removeFormat"
                            ],
                            ["quote", "unordered", "ordered"],
                            ["custom_btn"]
                          ],
                          definitions: {
                            bold: { label: null, icon: "fas fa-bold" },
                            italic: { label: null, icon: "fas fa-italic" },
                            strike: {
                              label: null,
                              icon: "fas fa-strikethrough"
                            },
                            underline: {
                              label: null,
                              icon: "fas fa-underline"
                            },
                            left: { label: null, icon: "fas fa-align-left" },
                            center: {
                              label: null,
                              icon: "fas fa-align-center"
                            },
                            right: { label: null, icon: "fas fa-align-right" },
                            justify: {
                              label: null,
                              icon: "fas fa-align-justify"
                            },
                            link: { label: null, icon: "fas fa-link" },
                            upload: {
                              tip: null,
                              icon: "fas fa-file-image",
                              handler: _vm.insertImg
                            },
                            removeFormat: {
                              label: null,
                              icon: "fas fa-eraser"
                            },
                            quote: { label: null, icon: "fas fa-quote-right" },
                            unordered: { label: null, icon: "fas fa-list-ul" },
                            ordered: { label: null, icon: "fas fa-list-ol" }
                          }
                        },
                        model: {
                          value: _vm.content,
                          callback: function($$v) {
                            _vm.content = $$v
                          },
                          expression: "content"
                        }
                      },
                      [
                        _c("q-btn", {
                          attrs: {
                            slot: "custom_btn",
                            dense: "",
                            flat: "",
                            color: "black",
                            icon: "fal fa-code",
                            label: "HTML"
                          },
                          on: {
                            click: function($event) {
                              _vm.show_html = true
                            }
                          },
                          slot: "custom_btn"
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("q-select", {
                      ref: "timezone",
                      attrs: {
                        options: _vm.timezones,
                        "float-label": _vm.$t("timezone"),
                        filter: "",
                        error: _vm.$v.timezone.$error
                      },
                      on: { input: _vm.$v.timezone.$touch },
                      model: {
                        value: _vm.timezone,
                        callback: function($$v) {
                          _vm.timezone = $$v
                        },
                        expression: "timezone"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-6" },
                  [
                    _c("q-datetime", {
                      ref: "publish_date",
                      attrs: {
                        type: "datetime",
                        "float-label": _vm.$t("publish_date"),
                        format: "DD/MM/YYYY HH:mm"
                      },
                      model: {
                        value: _vm.publish_date,
                        callback: function($$v) {
                          _vm.publish_date = $$v
                        },
                        expression: "publish_date"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-6" },
                  [
                    _c("q-datetime", {
                      ref: "unpublish_date",
                      attrs: {
                        type: "datetime",
                        "float-label": _vm.$t("unpublish_date"),
                        format: "DD/MM/YYYY HH:mm"
                      },
                      model: {
                        value: _vm.unpublish_date,
                        callback: function($$v) {
                          _vm.unpublish_date = $$v
                        },
                        expression: "unpublish_date"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12" },
                  [
                    _c("q-select", {
                      attrs: {
                        options: _vm.optionTags,
                        "float-label": _vm.$t("tags"),
                        multiple: "",
                        chips: "",
                        filter: "",
                        "autofocus-filter": ""
                      },
                      model: {
                        value: _vm.tag,
                        callback: function($$v) {
                          _vm.tag = $$v
                        },
                        expression: "tag"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c(
                "q-tabs",
                {
                  staticClass: "shadow-1",
                  attrs: { color: "secondary" },
                  model: {
                    value: _vm.tab,
                    callback: function($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab"
                  }
                },
                [
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "permissions",
                      icon: "fal fa-clipboard-list-check",
                      label: _vm.$t("permissions")
                    },
                    slot: "title"
                  }),
                  _c(
                    "q-tab-pane",
                    {
                      staticClass: "q-px-lg q-pb-xl",
                      attrs: { name: "permissions" }
                    },
                    [
                      _c("div", { staticClass: "row gutter-sm" }, [
                        _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-12" },
                          [
                            _c("p", { staticClass: "caption" }, [
                              _vm._v(_vm._s(_vm.$t("areas")))
                            ]),
                            _c("q-checkbox", {
                              staticClass: "q-mb-sm",
                              attrs: {
                                val: true,
                                label: _vm.$t("select_all_areas")
                              },
                              on: {
                                input: function($event) {
                                  return _vm.checkAllAreas()
                                }
                              },
                              model: {
                                value: _vm.all_areas,
                                callback: function($$v) {
                                  _vm.all_areas = $$v
                                },
                                expression: "all_areas"
                              }
                            }),
                            _c("select-multiple", {
                              attrs: {
                                filters: _vm.area,
                                options: _vm.areas,
                                error: _vm.$v.area.$error,
                                input: _vm.$v.area.$touch
                              },
                              on: {
                                on_value: function($event) {
                                  _vm.area = $event
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
                          _c("p", { staticClass: "caption" }, [
                            _vm._v(_vm._s(_vm.$t("profiles")))
                          ]),
                          _c(
                            "div",
                            { staticClass: "row gutter-sm" },
                            [
                              _c(
                                "div",
                                { staticClass: "col-xs-12 col-sm-12" },
                                [
                                  _c("q-checkbox", {
                                    attrs: { val: true, label: _vm.$t("all") },
                                    on: {
                                      input: function($event) {
                                        return _vm.checkAll()
                                      }
                                    },
                                    model: {
                                      value: _vm.all_profiles,
                                      callback: function($$v) {
                                        _vm.all_profiles = $$v
                                      },
                                      expression: "all_profiles"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._l(_vm.profiles, function(item, index) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticClass: "col-xs-12 col-sm-4",
                                    class: _vm.getErrorClass(
                                      _vm.$v.profile.$error
                                    )
                                  },
                                  [
                                    _c("q-checkbox", {
                                      ref: "profile",
                                      refInFor: true,
                                      attrs: {
                                        "keep-color": "",
                                        val: item.value,
                                        label: item.label,
                                        color: _vm.getErrorColor(
                                          _vm.$v.profile.$error
                                        )
                                      },
                                      on: { input: _vm.$v.profile.$touch },
                                      model: {
                                        value: _vm.profile,
                                        callback: function($$v) {
                                          _vm.profile = $$v
                                        },
                                        expression: "profile"
                                      }
                                    })
                                  ],
                                  1
                                )
                              }),
                              _c(
                                "div",
                                { staticClass: "col-xs-12 col-sm-12" },
                                [
                                  _c("q-select", {
                                    ref: "user_group",
                                    attrs: {
                                      options: _vm.user_groups,
                                      "float-label": _vm.$t("groups"),
                                      error: _vm.$v.user_group.$error,
                                      multiple: "",
                                      chips: ""
                                    },
                                    on: { input: _vm.$v.user_group.$touch },
                                    model: {
                                      value: _vm.user_group,
                                      callback: function($$v) {
                                        _vm.user_group = $$v
                                      },
                                      expression: "user_group"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            2
                          )
                        ])
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm.id_news != ""
                ? _c("div", { staticClass: "row gutter-sm q-my-sm" }, [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-11" },
                      [
                        _c("q-input", {
                          attrs: {
                            "float-label": _vm.$t("link"),
                            disable: true
                          },
                          model: {
                            value: _vm.url_news,
                            callback: function($$v) {
                              _vm.url_news = $$v
                            },
                            expression: "url_news"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-1 q-mt-lg" },
                      [
                        _c(
                          "q-btn",
                          {
                            staticClass: "full-width",
                            attrs: {
                              dense: "",
                              color: "primary",
                              icon: "fal fa-copy"
                            },
                            on: {
                              click: function($event) {
                                return _vm.copyLink()
                              }
                            }
                          },
                          [
                            _c("q-tooltip", [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(_vm.$t("copy_link")) +
                                  "\n\t\t\t\t\t\t"
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _c("div", { staticClass: "row gutter-sm q-my-sm" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12" },
                  [
                    _c("p", { staticClass: "caption" }, [
                      _vm._v(_vm._s(_vm.$t("status")))
                    ]),
                    _c("q-btn-toggle", {
                      attrs: {
                        "toggle-color": _vm.getColorStatus,
                        options: _vm.statuses
                      },
                      model: {
                        value: _vm.status,
                        callback: function($$v) {
                          _vm.status = $$v
                        },
                        expression: "status"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
                _c(
                  "div",
                  {
                    staticClass: "col-xs-12 col-sm-3",
                    class: _vm.getOrder("cancel")
                  },
                  [
                    _c("q-btn", {
                      staticClass: "full-width",
                      attrs: {
                        color: "tertiary",
                        label: _vm.$t("back"),
                        icon: "far fa-chevron-left"
                      },
                      on: {
                        click: function($event) {
                          return _vm.$router.push({ name: "admin_news" })
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "col-xs-12 col-sm-3",
                    class: _vm.getOrder("save")
                  },
                  [
                    _c("q-btn", {
                      staticClass: "full-width",
                      attrs: {
                        color: "secondary",
                        label: _vm.$t("save"),
                        icon: "far fa-save"
                      },
                      on: {
                        click: function($event) {
                          return _vm.saveData()
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "comments" } },
            [_c("comments", { attrs: { origin: "news" } })],
            1
          )
        ],
        1
      ),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            },
            "no-backdrop-dismiss": "",
            "no-esc-dismiss": ""
          },
          model: {
            value: _vm.show_html,
            callback: function($$v) {
              _vm.show_html = $$v
            },
            expression: "show_html"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_html = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [_vm._v("\n\t\t\t\t\tHTML\n\t\t\t\t")])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("q-input", {
                        attrs: {
                          type: "textarea",
                          rows: "10",
                          "float-label": "HTML"
                        },
                        model: {
                          value: _vm.content,
                          callback: function($$v) {
                            _vm.content = $$v
                          },
                          expression: "content"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "row gutter-sm justify-end q-mt-lg" },
                  [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-3" },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "tertiary",
                            label: _vm.$t("close"),
                            icon: "far fa-ban"
                          },
                          on: {
                            click: function($event) {
                              _vm.show_html = false
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }